import { render, staticRenderFns } from "./settings-footer.vue?vue&type=template&id=4ed2adc5"
import script from "./settings-footer.vue?vue&type=script&lang=js"
export * from "./settings-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports